import React, { useState } from "react";
import headingImg from "../../assets/img/heading-img.png";
import bannerBg from "../../assets/img/bannr-img.jpg";
import colorBG from "../../assets/img/color-bg.jpg";
import courseDetailsImg from "../../assets/img/courses-details-1.jpg";
import courseDetailsImg2 from "../../assets/img/courses-details-2.jpg";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./CourseDetails.css";

const CourseDetails = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (e, index) => {
    e.preventDefault();

    setActiveIndex(activeIndex === index ? null : index);
  };
  const { id } = useParams();
  //   const navigate = useNavigate();

  return (
    <div>
      <section
        className="bannr-section"
        style={{
          backgroundImage: `url(${bannerBg})`,
        }}
      >
        <div className="container">
          <div className="bannr-text">
            <img src={headingImg} alt="icon" />
            <h2>Our Courses</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                <NavLink to="/courses">Courses</NavLink>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                Course Details
              </li>
            </ol>
          </div>
        </div>
      </section>
      <section className="gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="courses-details hoverimg">
                <figure>
                  <img src={courseDetailsImg} alt="img" />
                </figure>
                <h5>Quran Intermediate Course</h5>
                <div className="d-flex align-items-center flex-wrap">
                  <div className="scholar">
                    <div>
                      <h4>Habib Al Noor</h4>
                      <span>Arabic scholar</span>
                    </div>
                  </div>
                </div>
                <p>
                  Phasellus enim libero, blandit vel sapienvitae, condimen tum
                  ultricies magna Lorem mod temincidid unt ut labore et dolore
                  magna aliqua vulputate cursus a sit am veli N nt taciti socio
                  Etiam ante ex fer mentodio Sed non erat it consequat aucto
                  odicons habitant morbi trist ique netus et malesuada. Ph
                  asellus enim liberod do eiusmod te dolore magna aliqua
                  vulputate cursus a sit am veli Nam mauctor Class aptent taciti
                  mentodio Sed non erat it consequat aucto odiconse.
                </p>
              </div>
              <div className="comment">
                <h3>Course Content</h3>
                <div className="accordion">
                  <div
                    className={`accordion-item ${
                      activeIndex === 0 ? "active" : ""
                    }`}
                  >
                    <a
                      href="javascript;"
                      className="heading"
                      onClick={(e) => handleClick(e, 0)}
                    >
                      <div className="icon">
                        {activeIndex === 0 ? (
                          <FontAwesomeIcon icon={faChevronDown} />
                        ) : (
                          <FontAwesomeIcon icon={faChevronRight} />
                        )}
                      </div>
                      <div className="title">Lesson 1 : Preview</div>
                    </a>
                    <div
                      className="content"
                      style={{ display: activeIndex === 0 ? "block" : "none" }}
                    >
                      <ul className="client-info">
                        <li>
                          <h5>
                            <b>Episode 1:</b> Ibrahim (AS) and his Father
                          </h5>
                        </li>
                        <li>
                          <h5>
                            <b>Episode 2:</b> Ibrahim (AS) breaks the idols
                          </h5>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className={`accordion-item ${
                      activeIndex === 1 ? "active" : ""
                    }`}
                  >
                    <a
                      href="javascript;"
                      className="heading"
                      onClick={(e) => handleClick(e, 1)}
                    >
                      <div className="icon">
                        {activeIndex === 1 ? (
                          <FontAwesomeIcon icon={faChevronDown} />
                        ) : (
                          <FontAwesomeIcon icon={faChevronRight} />
                        )}{" "}
                      </div>
                      <div className="title">Lesson 2 : Preview</div>
                    </a>
                    <div
                      className="content"
                      style={{ display: activeIndex === 1 ? "block" : "none" }}
                    >
                      <ul className="client-info">
                        <li>
                          <h5>
                            <b>Episode 1:</b> Ibrahim (AS) and his Father
                          </h5>
                        </li>
                        <li>
                          <h5>
                            <b>Episode 2:</b> Ibrahim (AS) breaks the idols
                          </h5>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className={`accordion-item ${
                      activeIndex === 2 ? "active" : ""
                    }`}
                  >
                    <a
                      href="javascript;"
                      className="heading"
                      onClick={(e) => handleClick(e, 2)}
                    >
                      <div className="icon">
                        {activeIndex === 2 ? (
                          <FontAwesomeIcon icon={faChevronDown} />
                        ) : (
                          <FontAwesomeIcon icon={faChevronRight} />
                        )}{" "}
                      </div>
                      <div className="title">Lesson 3 : Preview</div>
                    </a>
                    <div
                      className="content"
                      style={{ display: activeIndex === 2 ? "block" : "none" }}
                    >
                      <ul className="client-info">
                        <li>
                          <h5>
                            <b>Episode 1:</b> Ibrahim (AS) and his Father
                          </h5>
                        </li>
                        <li>
                          <h5>
                            <b>Episode 2:</b> Ibrahim (AS) breaks the idols
                          </h5>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className={`accordion-item ${
                      activeIndex === 3 ? "active" : ""
                    }`}
                  >
                    <a
                      href="javascript;"
                      className="heading"
                      onClick={(e) => handleClick(e, 3)}
                    >
                      <div className="icon">
                        {activeIndex === 3 ? (
                          <FontAwesomeIcon icon={faChevronDown} />
                        ) : (
                          <FontAwesomeIcon icon={faChevronRight} />
                        )}{" "}
                      </div>
                      <div className="title">Lesson 4 : Preview</div>
                    </a>
                    <div
                      className="content"
                      style={{ display: activeIndex === 3 ? "block" : "none" }}
                    >
                      <ul className="client-info">
                        <li>
                          <h5>
                            <b>Episode 1:</b> Ibrahim (AS) and his Father
                          </h5>
                        </li>
                        <li>
                          <h5>
                            <b>Episode 2:</b> Ibrahim (AS) breaks the idols
                          </h5>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="courses-details-sidebar">
                <div className="video position-relative">
                  <a
                    data-fancybox=""
                    href="https://www.youtube.com/watch?v=xKxrkht7CpY"
                  >
                    <i>
                      <svg
                        width="11"
                        height="17"
                        viewBox="0 0 11 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 8.49951L0.5 0.27227L0.5 16.7268L11 8.49951Z"
                          fill="#000"
                        ></path>
                      </svg>
                    </i>
                  </a>
                  <img src={courseDetailsImg2} alt="img" />
                </div>
                <div className="course-free">
                  <h5>Course Fee</h5>
                  <h6>
                    <del>$24.00</del> $16.00
                  </h6>
                  <div className="travel-package-list">
                    <h4>Includes:</h4>
                    <ul>
                      <li>
                        <FontAwesomeIcon icon={faCircleCheck} />2 hours
                        on-demand vide
                      </li>
                      <li>
                        <FontAwesomeIcon icon={faCircleCheck} />
                        English
                      </li>
                      <li>
                        <FontAwesomeIcon icon={faCircleCheck} />
                        Full lifetime access
                      </li>
                      <li>
                        <FontAwesomeIcon icon={faCircleCheck} />
                        Access on mobile and TV
                      </li>
                      <li>
                        <FontAwesomeIcon icon={faCircleCheck} />2 hours of audio
                        lessons
                      </li>
                      <li>
                        <FontAwesomeIcon icon={faCircleCheck} />
                        E-Book
                      </li>
                      <li>
                        <FontAwesomeIcon icon={faCircleCheck} />
                        Certificate of completion
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="about-instructor"
                  style={{
                    backgroundImage: `url(${colorBG})`,
                  }}
                >
                  <div className="course-details-scholar">
                    <div>
                      <h4>About Instructor</h4>
                      <span>24 Courses</span>
                      <ul className="star">
                        <li>
                          <FontAwesomeIcon icon={faStar} />
                        </li>
                        <li>
                          <FontAwesomeIcon icon={faStar} />
                        </li>
                        <li>
                          <FontAwesomeIcon icon={faStar} />
                        </li>
                        <li>
                          <FontAwesomeIcon icon={faStar} />
                        </li>
                        <li>
                          <FontAwesomeIcon icon={faStar} />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p>
                    he memorized the Quran at a young age then went on to
                    complete a BA in Islamic L aw from the University of Madinah
                  </p>
                  <a href="#">
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span>View Profile</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CourseDetails;
